var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('amplify-auth-container',[_c('amplify-authenticator',[_c('amplify-sign-in',{attrs:{"slot":"sign-in","hide-sign-up":"false","formFields":_vm.formFields},slot:"sign-in"})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }